import axios from "axios";
import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { toast } from 'react-toastify';
import { CloseButton, DropdownItem, DropdownMenu, DropdownToggle, Input, Modal, ModalBody, ModalHeader, UncontrolledDropdown } from 'reactstrap';
import { base_url } from '../../../../constants';
import TableContainer from "./../../../../components/Common/TableContainer";
import './courselist.css';
const CourseListTable = ({ Courses, showHideCourse, getCourses }) => {
  const localdata = localStorage.getItem('elmatary_admin');
  let adminData = localdata && JSON.parse(localdata);
  const navigate = useNavigate();
  const [showcourseedit, setshowcourseedit] = useState(false);
  const [rowdata, setrowdata] = useState({});
  const [image, setimage] = useState(false);
  const [selectedGrade, setSelectedGrade] = useState(false);
  const [selectedUniv, setSelectedUniv] = useState(false);

  // const navigate=useNavigate();
  const [category, setCategory] = useState(false);

  // const getCategories = async () => {
  //   const data_send={
  //     admin_id:adminData.admin_id,
  //     access_token:adminData.access_token,
  //   }
  //   const getcategories = await axios.post(base_url+"/admin/courses/select_category.php",JSON.stringify(data_send));
  //   console.log(getcategories)
  //   setCategory(getcategories);
  // }
  const [selectedCategory, setSelectedCategory] = useState(false)
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [allAdmins, setAllAdmins] = useState([]);
  const [selectedAdminsToAssign, setSelectedAdminsToAssign] = useState([]);
  const [courseAdmins, setCourseAdmins] = useState([]);
  const [loadingAdmins, setLoadingAdmins] = useState(false);

  const getAllAdmins = async () => {
    const send_data = {
      admin_id: adminData.admin_id,
      access_token: adminData.access_token,
    };
    try {
      const res = await axios.post(base_url + "/admin/auth/list.php", send_data);
      if (res.status === "success") {
        setAllAdmins(res.message.map(admin => ({
          value: admin.admin_user_id,
          label: admin.user_name
        })));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCourseAdmins = async (course_id) => {
    setLoadingAdmins(true);
    const send_data = {
      admin_id: adminData.admin_id,
      access_token: adminData.access_token,
      course_id: course_id
    };
    try {
      // Assuming there's an API to get admins for a specific course
      // If not, we might need to adjust based on backend availability
      const res = await axios.post(base_url + "/admin/courses/select_course_admins.php", send_data);
      if (res.status === "success") {
        setCourseAdmins(res.message);
      } else {
        setCourseAdmins([]);
      }
    } catch (err) {
      console.log(err);
      setCourseAdmins([]);
    } finally {
      setLoadingAdmins(false);
    }
  };

  const handleAssignAdmins = async () => {
    if (!selectedAdminsToAssign.length) {
      toast.error("Please select at least one admin");
      return;
    }

    setLoadingAdmins(true);
    try {
      // The requirement says "select more than one admin"
      // We will loop and assign each or send as array if API supports it
      // Based on user prompt "course_id" and "admin_id", it might be one by one
      for (const admin of selectedAdminsToAssign) {
        const send_data = {
          admin_id: adminData.admin_id,
          access_token: adminData.access_token,
          course_id: rowdata.course_id,
          target_admin_id: admin.value // Using target_admin_id to distinguish from logged in admin
        };
        // Using the user provided endpoint
        await axios.post(base_url + "/admin/courses/assign_course_to_admins.php", send_data);
      }
      toast.success("Admins assigned successfully");
      setShowAssignModal(false);
      setSelectedAdminsToAssign([]);
    } catch (err) {
      toast.error("Error assigning admins");
    } finally {
      setLoadingAdmins(false);
    }
  };

  const handleRemoveAdminFromCourse = async (target_admin_id) => {
    const send_data = {
      admin_id: adminData.admin_id,
      access_token: adminData.access_token,
      course_id: rowdata.course_id,
      target_admin_id: target_admin_id
    };
    try {
      const res = await axios.post(base_url + "/admin/courses/delete_admin_from_course.php", send_data);
      if (res.status === "success") {
        toast.success("Admin removed successfully");
        getCourseAdmins(rowdata.course_id);
      } else {
        toast.error(res.message || "Error removing admin");
      }
    } catch (err) {
      toast.error("Error removing admin");
    }
  };

  useEffect(() => {
    getAllAdmins();
  }, []);

  const handleupdatecourse = () => {
    const formdata = new FormData();
    formdata.append("image", image);
    console.log(rowdata);
    // alert("Edit Course")

    axios.post("https://medicotoon.com/medicotoon/backend/admin/image_uploader.php", formdata)
      .then((res) => {

        const data_send = {
          admin_id: adminData.admin_id,
          access_token: adminData.access_token,
          course_name: rowdata.course_name,
          course_price: rowdata.course_price,
          course_content: rowdata.course_content,
          course_photo_url: !image ? rowdata.course_photo_url : res,
          course_id: rowdata.course_id,
          grade_id: selectedGrade,
          university_id: selectedUniv,
          category_id: selectedCategory,
          course_type: rowdata?.course_type || "normal",
          pdf_url: rowdata?.pdf_url,
          show_in_website: rowdata?.show_in_website ?? 0,
          show_in_mobile: rowdata?.show_in_mobile ?? 0,
        }
        axios.post(base_url + "/admin/courses/edit_course.php", JSON.stringify(data_send))
          .then((res) => {
            console.log(res)
            if (res.message == 'Session Expired') {
              localStorage.removeItem('elmatary_admin');
              navigate('/login', { replace: true })
            }
            if (res.status == 'success') {
              setshowcourseedit(false);
              toast.success(res.message);
              setrowdata(false);
              getCourses();
              setSelectedGrade(false);
              setSelectedUniv(false);
            }
            else if (res.status == 'error') {
              toast.error(res.message);
            }
            else {
              toast.error("Something Went Error");
            }
          }).catch(err => toast.error(err))

      }).catch(err => toast.error(err))

  }
  const [item, setItem] = useState(false)
  const [copyCourse, setCopyCourse] = useState(false);
  useEffect(() => {
    setSelectedGrade(rowdata.grade_id);
    setSelectedUniv(rowdata.university_id);
    setSelectedCategory(rowdata.category_id)
  }, [rowdata]);
  const columns = [
    {
      accessor: 'course_photo_url',
      Cell: (cell) => {
        return (<>
          <div>
            <div onClick={
              () => {
                console.log(cell.cell.row.original);
                navigate("/units", {
                  state: {
                    coursedata: cell.cell.row.original
                  }
                })
              }
            } style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              cursor: 'pointer',
              justifyContent: 'center'
            }}>
              <span id='id' style={{ display: "none" }}>{JSON.stringify(cell.cell.row.original)}</span>
              {
                cell.cell.row.original.course_photo_url ? (
                  <img style={{ height: "150px" }} src={cell.cell.row.original.course_photo_url} alt="" />
                ) : (
                  <img style={{ height: "150px" }} src={require("../../../../assets/images/noimage.png")} alt="" />
                )
              }
            </div>
            <div onClick={
              () => {
                console.log(cell.cell.row.original);
                navigate("/units", {
                  state: {
                    coursedata: cell.cell.row.original
                  }
                })
              }
            } style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderBottom: '1px solid #ccc',
              flexDirection: "column",
              cursor: 'pointer',
              padding: '10px 0px',
              gap: '4px'
            }} className='course_name'>
              <div className="d-flex align-items-center gap-2">
                <span style={{
                  fontSize: '20px',
                  fontWeight: '700'
                }}>{cell.cell.row.original.course_name || "No Name"}</span>
                {cell.cell.row.original.course_type === "questions" ? (
                  <span className="badge bg-soft-warning text-warning font-size-12">Questions Only</span>
                ) : (
                  <span className="badge bg-soft-primary text-primary font-size-12">Normal</span>
                )}
              </div>
              <span style={{
                fontSize: '16px',
                fontWeight: '500',
                display: "block"
              }}>{cell.cell.row.original?.university_name || "No University"}/{cell.cell.row.original?.grade_name || "No Grade"}</span>
            </div>
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
            margin: "20px 0"
          }}>


            <button onClick={
              () => {
                console.log(cell.cell.row.original);
                navigate("/units", {
                  state: {
                    coursedata: cell.cell.row.original
                  }
                })
              }
            } className='btn btn-primary'>View</button>
            {/* <button onClick={
              () => {
                console.log(cell.cell.row.original);
                setrowdata(cell.cell.row.original);
                setCopyCourse(true)
              }
            } className='btn btn-primary'>Duplicate Course</button> */}

            <UncontrolledDropdown className="DropVidUn">
              <DropdownToggle className="btn btn-light btn-sm" tag="button" data-bs-toggle="dropdown" direction="start">
                <i className="bx bx-dots-horizontal-rounded"></i>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                {/* <DropdownItem>
                  <span onClick={
                    () => {
                      console.log(cell.cell.row.original.course_id);
                      navigate("/exam", { state: { course_data: cell.cell.row.original } })
                      // setshowcourseedit(true);
                      // setrowdata(cell.cell.row.original);
                      // console.log(cell.cell.row.original)
                    }
                  }>
                    <button className='btn btn-primary' style={{ width: "100%" }}>Exams</button>
                  </span>
                </DropdownItem> */}
             {(adminData?.admin_id == 26 || adminData?.admin_id == 32) &&   <DropdownItem>
                  <span onClick={
                    () => {
                      setshowcourseedit(true);
                      setrowdata(cell.cell.row.original);
                      console.log(cell.cell.row.original)
                    }
                  }>
                    <button className='btn btn-primary' style={{ width: "100%" }}>Edit</button>
                  </span>
                </DropdownItem>}
               {(adminData?.admin_id == 26 || adminData?.admin_id == 32) && <DropdownItem>
                  {
                    cell.cell.row.original.hidden == 'no' ?
                      (

                        <span style={{
                          width: '25px',
                          cursor: 'pointer'
                        }} onClick={
                          () => {
                            const item = cell.cell.row.original;
                            console.log(item)
                            const send_data = {
                              status: "yes",
                              course_id: item.course_id
                            }
                            showHideCourse(send_data);

                          }
                        }>
                          <button className='btn btn-danger' style={{ width: "100%" }}>Hide</button>
                        </span>
                      )
                      :
                      (
                        <span style={{
                          width: '25px',
                          cursor: 'pointer'
                        }} onClick={
                          () => {
                            const item = cell.cell.row.original;
                            console.log(item)
                            const send_data = {
                              status: "no",
                              course_id: item.course_id
                            }
                            showHideCourse(send_data);

                          }
                        }>
                          <button className='btn btn-success' style={{ width: "100%" }}>Show</button>
                        </span>
                      )
                  }
                </DropdownItem>}
                {/* <DropdownItem>
                  <span onClick={
                    () => {
                      setshowcourseedit(true);
                      setrowdata(cell.cell.row.original);
                      console.log(cell.cell.row.original)
                    }
                  }>
                 
                  </span>
                </DropdownItem> */}
                {/* <DropdownItem>
                  <span onClick={
                    () => {
                      navigate("/coursesqueries", { state: { course_data: cell.cell.row.original } })
                      // setshowcourseedit(true);
                      // setrowdata(cell.cell.row.original);
                      // console.log(cell.cell.row.original)
                    }
                  }>
                    <button className='btn btn-warning' style={{ width: "100%" }}>Student Questions</button>
                  </span>
                </DropdownItem> */}
                {(adminData?.admin_id == 26 || adminData?.admin_id == 32) &&<DropdownItem>
                  <span onClick={() => {
                    setrowdata(cell.cell.row.original);
                    setShowAssignModal(true);
                  }}>
                    <button className='btn btn-info' style={{ width: "100%" }}>Assign Admins</button>
                  </span>
                </DropdownItem>}
                {(adminData?.admin_id == 26 || adminData?.admin_id == 32) && <DropdownItem>
                  <span onClick={() => {
                    setrowdata(cell.cell.row.original);
                    setShowRemoveModal(true);
                    getCourseAdmins(cell.cell.row.original.course_id);
                  }}>
                    <button className='btn btn-secondary' style={{ width: "100%" }}>Remove Admins</button>
                  </span>
                </DropdownItem>}

              </DropdownMenu>
            </UncontrolledDropdown >

          </div >

        </>
        )
      }
    },

  ]
  const [universities, setuniversities] = useState([])
  const [grades, setgrades] = useState([])

  const getuniversities = () => {
    const data_send = {
      admin_id: adminData.admin_id,
      access_token: adminData.access_token,
    }
    axios.post(base_url + "/admin/universities/select_universities_grade.php", JSON.stringify(data_send))
      .then((res) => {
        // console.log(res)
        if (res.message == 'Session Expired') {
          localStorage.removeItem('elmatary_admin');
          navigate('/login', { replace: true })
        }
        if (res.status == 'success') {
          setuniversities(res.message);
        }
      })
      .catch(err => console.log(err));
  }


  const getgrades = () => {
    setgrades(universities.filter(item => item.university_id == selectedUniv)[0]?.grades);
  }

  useEffect(() => {
    getuniversities();
  }, [])

  useEffect(() => {
    getgrades();
    console.log("res", selectedUniv);
  }, [selectedUniv]);

  useEffect(() => {
    if (grades && grades.length) {
      setSelectedGrade(grades[0]?.grade_id)
    }
  }, [grades])

  const duplicateCourse = (e) => {
    const data_send = {
      course_id: rowdata.course_id,
      grade_id: selectedGrade,
      university_id: selectedUniv,
      admin_id: adminData.admin_id,
      access_token: adminData.access_token,
    }
    console.log(data_send);
    axios.post(base_url + "/admin/courses/make_copy_from_course.php", JSON.stringify(data_send))
      .then((res) => {
        console.log(res)
        if (res.message == 'Session Expired') {
          // toast.error();
          localStorage.removeItem('elmatary_admin');
          navigate('/login', { replace: true })
        }
        if (res.status == 'success') {
          setshowcourseedit(false);
          toast.success(res.message);
          setrowdata(false);
          getCourses();
          setSelectedGrade(false);
          setSelectedUniv(false);
        }
        else if (res.status == 'error') {
          toast.error(res.message);
        }
        else {
          toast.error("Something Went Error");
        }
      }).catch(err => console.log(err))
  }

  return (
    <React.Fragment>

      {Courses ? <TableContainer columns={columns}
        data={Courses}
        isGlobalFilter={true}
        customPageSize={10}
        className="Invoice table course_table"
        tableName="courses"
        idField="course_id" /> : <Fragment />}
      <Modal isOpen={showcourseedit}>
        <ModalHeader
          tag="h4">
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
            <h4>Update Course Data</h4>
            <CloseButton onClick={
              () => {
                setshowcourseedit(false);
              }
            }
              style={
                { marginLeft: "auto" }
              } />
          </div>
        </ModalHeader>
        <ModalBody>

          <form
            style={
              {
                padding: "15px",
                display: "flex",
                flexDirection: "column"
              }
            }
            onSubmit={
              (e) => {
                e.preventDefault();
                // AssignVideo(e)
                handleupdatecourse()
              }
            }>
            <div className="input_Field">
              <label htmlFor="">Title</label>
              <Input style={
                {
                  width: "100%",
                  borderRadius: "4px",
                  margin: "10px 0"
                }
              }
                onChange={(e) => {
                  setrowdata({ ...rowdata, course_name: e.target.value })
                }}
                value={rowdata.course_name}
                type="text"
                name="new_title"
                id="new_title"
                placeholder="Enter Course Title"
              />

            </div>


            <div className="input_Field">
              <label htmlFor="">Course Price</label>
              <Input style={
                {
                  width: "100%",
                  borderRadius: "4px",
                  margin: "10px 0"
                }
              }
                onChange={(e) => {
                  setrowdata({ ...rowdata, course_price: e.target.value })
                }}
                value={rowdata.course_price}
                type="text"
                name="new_title"
                id="new_title"
                placeholder="Enter Course Price"
              />

            </div>
            {/* <div className="mb-3">
              <label htmlFor="category_id" className="form-label">
                Category
              </label>
              {category && category.length ?
                <select value={selectedCategory} onChange={(e) => {
                  setSelectedCategory(e.target.value)
                }} className="form-control" data-trigger name="choices-single-category" id="choices-single-category">
                  {
                    category.map((item, index) => {
                      return (
                        <option value={item.category_id}>{item.category_label}</option>

                      )
                    })
                  }
                </select> : null}
            </div> */}
            <div className="input_Field mb-3">
              <label htmlFor="" className="fw-semibold">Course Type</label>
              <select
                className="form-select"
                value={rowdata.course_type || "normal"}
                onChange={(e) => {
                  setrowdata({ ...rowdata, course_type: e.target.value });
                }}
              >
                <option value="normal">Normal Course (Videos & Lessons)</option>
                <option value="questions">Questions Only (Question Bank)</option>
              </select>
            </div>

            <div className="input_Field">
              <label htmlFor="">Course Image</label>
              <Input style={
                {
                  width: "100%",
                  borderRadius: "4px",
                  margin: "10px 0"
                }
              }
                onChange={(e) => {
                  setimage(e.target.files[0]);
                  // setrowdata({...rowdata,course_photo_url:e.target.files[0]})
                }}
                type="file"
                name="new_title"
                id="new_title"
                placeholder="Enter new_title"
              />

            </div>
            <div className="input_Field">
              <label htmlFor="">Books URL</label>
              <Input style={
                {
                  width: "100%",
                  borderRadius: "4px",
                  margin: "10px 0"
                }
              }
                onChange={(e) => {
                  setrowdata({ ...rowdata, pdf_url: e.target.value })
                }}
                value={rowdata.pdf_url}
                type="text"
                name="new_title"
                id="new_title"
                placeholder="Enter Books URL"
              />

            </div>

            <div className="input_Field">
              <label htmlFor="">University</label>
              <select onChange={(e) => {
                setrowdata({ ...rowdata, university_id: e.target.value })
              }} className="form-control" data-trigger name="choices-single-category" id="" >
                {
                  universities.map((item, index) => {
                    return (
                      <option value={item.university_id}>{item.university_name}</option>
                    )
                  })
                }
              </select>

            </div>

            <div className="input_Field">
              <label htmlFor="">Grade</label>
              <select onChange={(e) => {
                setrowdata({ ...rowdata, grade_id: e.target.value })
              }} className="form-control" data-trigger name="choices-single-category" id="" >
                {
                  grades && grades.length ? grades.map((item, index) => {
                    return (
                      <option value={item.grade_id}>{item.grade_name}</option>
                    )
                  }) : null
                }
              </select>

            </div>

            <div className="input_Field">
              <label htmlFor="">Course Content</label>
              <textarea style={
                {
                  width: "100%",
                  borderRadius: "4px",
                  margin: "10px 0"
                }
              }
                onChange={(e) => {
                  setrowdata({ ...rowdata, course_content: e.target.value })
                }}
                value={rowdata.course_content}
                type="text"
                name="new_title"
                id="new_title"
                placeholder="Enter Course Content"
              />

            </div>




            <div style={{ display: "flex", gap: "30px", margin: "15px 0" }}>
              <div className="input_Field" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <label htmlFor="edit_show_in_website" className="mb-0">Show in Website</label>
                <div className="form-check form-switch mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="edit_show_in_website"
                    checked={rowdata?.show_in_website == 1}
                    onChange={(e) => setrowdata({ ...rowdata, show_in_website: e.target.checked ? 1 : 0 })}
                  />
                </div>
              </div>

              <div className="input_Field" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <label htmlFor="edit_show_in_mobile" className="mb-0">Show in Mobile</label>
                <div className="form-check form-switch mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="edit_show_in_mobile"
                    checked={rowdata?.show_in_mobile == 1}
                    onChange={(e) => setrowdata({ ...rowdata, show_in_mobile: e.target.checked ? 1 : 0 })}
                  />
                </div>
              </div>
            </div>

            <button className="btn btn-success"
              style={
                { margin: "10px 0 0 auto" }
              }>
              {" "}
              Update {" "}
            </button>
          </form>


        </ModalBody>
      </Modal>

      <Modal isOpen={copyCourse}>
        <ModalHeader
          tag="h4">
          <div style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
            <h4>Duplicate</h4>
            <CloseButton onClick={
              () => {
                setCopyCourse(false);
              }
            }
              style={
                { marginLeft: "auto" }
              } />
          </div>
        </ModalHeader>
        <ModalBody>
          <form
            style={
              {
                padding: "15px",
                display: "flex",
                flexDirection: "column"
              }
            }
            onSubmit={
              (e) => {
                e.preventDefault();
                // AssignVideo(e)
                duplicateCourse(e)
              }
            }>

            <div className="input_Field">
              <label htmlFor="">University</label>
              <select onChange={(e) => {
                // setrowdata({ ...rowdata, university_id: e.target.value })
                setSelectedUniv(e.target.value)

              }} className="form-control" data-trigger name="choices-single-category" id="" >
                {
                  universities.map((item, index) => {
                    return (
                      <option value={item.university_id}>{item.university_name}</option>
                    )
                  })
                }
              </select>

            </div>

            <div className="input_Field">
              <label htmlFor="">Grade</label>
              <select onChange={(e) => {
                // setrowdata({ ...rowdata, grade_id: e.target.value })
                setSelectedGrade(e.target.value)
              }} className="form-control" data-trigger name="choices-single-category" id="" >
                {
                  grades && grades.length ? grades.map((item, index) => {
                    return (
                      <option value={item.grade_id}>{item.grade_name}</option>
                    )
                  }) : null
                }
              </select>

            </div>


            <button className="btn btn-success"
              style={
                { margin: "10px 0 0 auto" }
              }>
              {" "}
              Duplicate {" "}
            </button>
          </form>


        </ModalBody>
      </Modal>

      {/* Assign Modal */}
      <Modal isOpen={showAssignModal} toggle={() => setShowAssignModal(false)}>
        <ModalHeader toggle={() => setShowAssignModal(false)}>Assign Course to Admins</ModalHeader>
        <ModalBody>
          <div className="mb-3">
            <label>Select Admins</label>
            <Select
              isMulti
              options={allAdmins}
              value={selectedAdminsToAssign}
              onChange={setSelectedAdminsToAssign}
              classNamePrefix="select2-selection"
            />
          </div>
          <div className="text-end">
            <button
              className="btn btn-success"
              onClick={handleAssignAdmins}
              disabled={loadingAdmins}
            >
              {loadingAdmins ? "Assigning..." : "Assign"}
            </button>
          </div>
        </ModalBody>
      </Modal>

      {/* Remove Modal */}
      <Modal isOpen={showRemoveModal} toggle={() => setShowRemoveModal(false)}>
        <ModalHeader toggle={() => setShowRemoveModal(false)}>
          Remove Admins from Course
        </ModalHeader>
        <ModalBody>
          {loadingAdmins ? (
            <div className="text-center">Loading...</div>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <thead>
                  <tr>
                    <th>Admin Name</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {courseAdmins && courseAdmins.length > 0 ? (
                    courseAdmins.map((admin, index) => (
                      <tr key={index}>
                        <td>{admin.user_name}</td>
                        <td>
                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleRemoveAdminFromCourse(admin.admin_user_id)}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2" className="text-center">No admins assigned to this course</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </ModalBody>
      </Modal>
    </React.Fragment>

  )
}

export default CourseListTable;
